export const comments_5089935 = {"data":{"data":[],"links":{}}}